<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{$route.meta.title}}
                        <el-button class="title_btn" type="primary" @click="$router.push('/config/refund/create')">등록</el-button>
                    </div>
                    <config-list-component :configType="'credit'"></config-list-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ConfigListComponent from "@/components/config/ConfigListComponent";
    export default {
        name: 'Credit',
        components: {
            ConfigListComponent
        },
        mixins: [ ],
        data() {
            return{

            }
        },
        mounted() {
        },
        computed: {
        },
        methods: {
        }
    }
</script>
